import React from 'react';
import Button from '@/components/ui/Button';
import {FormModal} from 'components/modals';
import i18n from 'i18n';

interface SearchIndexModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const SearchIndexModalComponent: React.FC<SearchIndexModalProps> = ({
    isOpen,
    onClose,
}) => {
    const createIndex = (): void => {
        // TODO: Implement createIndex functionality
    };

    const footer = (
        <>
            <Button data-dismiss="alert" variant="secondary" onClick={onClose} data-cy="search-index-btn">
                {i18n.t('jt_discard.text')}
            </Button>
            <Button onClick={createIndex} variant="info" data-cy="search-index-info-btn">
                {i18n.t('jt_create.text')}
            </Button>
        </>
    );

    return (
        <FormModal
            isOpen={isOpen}
            onClose={onClose}
            title={i18n.t('jt_search_index_create.text')}
            footer={footer}
        >
            <p>{i18n.t('jt_without_oversimplifying.text')}</p>
            <p>{i18n.t('jt_mentioned_previous.text')}</p>
            <p>{i18n.t('jt_you_can.text')}</p>
        </FormModal>
    );
};

const SearchIndexModal = React.memo(SearchIndexModalComponent);

export default SearchIndexModal;
